module.exports = __webpack_public_path__ + "img/bahathlogo.7b7e512a.webp";